export default __webpack_public_path__ + "static/media/loginBg.c4e2a70b.png";